var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSynchronization(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.55512 14.6751C7.47062 14.2738 7.13662 13.7506 6.70262 13.7428C6.66662 13.7438 6.63062 13.7463 6.59387 13.7463C3.94287 13.7463 1.79137 11.2413 1.79137 8.15257C1.79137 6.18107 2.66812 4.45007 3.99162 3.45482L4.29762 4.16407C4.49387 4.25882 4.78887 4.26657 5.09087 4.17032L7.38437 0.972816L3.38437 0.205566C3.09387 0.336566 2.88912 0.536816 2.81812 0.733316L3.19587 1.60957C1.29662 2.94982 0.0263672 5.37707 0.0263672 8.15207C0.0263672 12.2643 2.81137 15.6178 6.30387 15.7941C6.83487 15.7943 7.70487 15.3923 7.55387 14.6748",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.44547 1.32531C8.53097 1.72631 8.86297 2.24956 9.29797 2.25706C9.33422 2.25656 9.36972 2.25406 9.40672 2.25406C12.0585 2.25406 14.2092 4.75906 14.2092 7.84781C14.2092 9.81956 13.3315 11.5503 12.008 12.5458L11.7017 11.8366C11.507 11.7418 11.2115 11.7346 10.9095 11.8303L8.61497 15.0278L12.6175 15.7948C12.9077 15.6638 13.1117 15.4638 13.1835 15.2671L12.806 14.3906C14.705 13.0516 15.9752 10.6231 15.9752 7.84806C15.9752 3.73581 13.1892 0.382305 9.69772 0.206055C9.16647 0.205555 8.29572 0.607555 8.44772 1.32531",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSynchronization);
export default __webpack_public_path__ + "static/media/synchronization.05bf164e066abc1fe0abfcf608fbdf47.svg";
export { ForwardRef as ReactComponent };